import { Injectable } from '@angular/core';
import { Observable ,  BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class  SectionHeaderService {
  private _filterText: string;
  private _addItemClickedChanges: Subject<any> = new Subject<any>();
  private _filtersChanges: Subject<any> = new Subject<any>();
  private _filterTextChanges: BehaviorSubject<string> = new BehaviorSubject<string>('');

  set filterText(text: string) {
    this._filterText = text;
    this._filterTextChanges.next(text);
  }

  get filterText(): string {
    return this._filterText;
  }

  get addItemClickedChanges(): Observable<any> {
    return this._addItemClickedChanges.asObservable();
  }

  get filterTextChanges(): Observable<string> {
    return this._filterTextChanges.asObservable();
  }

  get filtersChanges(): Observable<any> {
    return this._filtersChanges.asObservable();
  }

  toggleFilters(): void {
    this._filtersChanges.next();
  }

  addItemClicked(): void {
    this._addItemClickedChanges.next();
  }
}
